import React from 'react'
import SimpleError500 from 'ui/modules/emptyState/error500'

const ServerError = () => {
  return <SimpleError500 />
}

export default ServerError
